import type { GenericLanguages } from '@payloadcms/translations'

export const i18n: Partial<GenericLanguages> = {
  ar: {
    label: 'قائمة التحقق',
  },
  az: {
    label: 'Yoxlama Siyahısı',
  },
  bg: {
    label: 'Списък за проверка',
  },
  cs: {
    label: 'Seznam kontrol',
  },
  da: {
    label: 'Tjekliste',
  },
  de: {
    label: 'Checkliste',
  },
  en: {
    label: 'Check List',
  },
  es: {
    label: 'Lista de comprobación',
  },
  et: {
    label: '',
  },
  fa: {
    label: 'لیست بررسی',
  },
  fr: {
    label: 'Liste de contrôle',
  },
  he: {
    label: 'רשימת בדיקה',
  },
  hr: {
    label: 'Kontrolni popis',
  },
  hu: {
    label: 'Ellenőrzőlista',
  },
  is: {
    label: 'Gátlisti',
  },
  it: {
    label: 'Lista di controllo',
  },
  ja: {
    label: 'チェックリスト',
  },
  ko: {
    label: '체크 리스트',
  },
  my: {
    label: 'Senarai Semak',
  },
  nb: {
    label: 'Sjekkliste',
  },
  nl: {
    label: 'Checklist',
  },
  pl: {
    label: 'Lista kontrolna',
  },
  pt: {
    label: 'Lista de Verificação',
  },
  ro: {
    label: 'Listă de verificare',
  },
  rs: {
    label: 'Контролна листа',
  },
  'rs-latin': {
    label: 'Kontrolna lista',
  },
  ru: {
    label: 'Список Проверки',
  },
  sk: {
    label: 'Kontrolný zoznam',
  },
  sl: {
    label: 'Nimekiri',
  },
  sv: {
    label: 'Kontrollista',
  },
  ta: {
    label: 'சரிபார்ப்பு பட்டியல்',
  },
  th: {
    label: 'รายการตรวจสอบ',
  },
  tr: {
    label: 'Kontrol Listesi',
  },
  uk: {
    label: 'Список перевірки',
  },
  vi: {
    label: 'Danh sách kiểm tra',
  },
  zh: {
    label: '检查清单',
  },
  'zh-TW': {
    label: '檢查清單',
  },
}
